class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends HTMLElement {

  constructor() {
    super();

    var eventType = this.dataset.type || 'click'
    var openOnHover = this.dataset.openOnHover
    /**
     * @type {'click' | 'hover'}
     */
    this.eventType = eventType
    /**
     * hover的时候打开 子菜单
     * @type {boolean}
     */
    this.openOnHover = openOnHover

    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.header = document.querySelector('.header-wrapper');

    this.bindEvents()
  }

  bindEvents() {
    this.onMoveout = throttle(this.onMoveout.bind(this), 500)

    switch (this.eventType) {
      case 'click':
        this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
        this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
        break;

      case 'hover':
        this.mainDetailsToggle.addEventListener('mouseenter', this.open.bind(this));
        this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
        break;

      default:
        break;
    }
  }

  onMoveout(event) {
    if (event.target.closest('header-menu') === this) return;
    this.close();
    document.body.removeEventListener("mousemove", this.onMoveout)
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }

  open() {
    const mainDetailsToggles = document.querySelectorAll('.header__inline-menu details');
    // 先关闭其他的。
    mainDetailsToggles.forEach((details) => {
      if (details !== this.mainDetailsToggle) {
        this.close(details);
      }
    });

    this.mainDetailsToggle.setAttribute('open', true);
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', true);
    if (this.eventType === 'hover') {
      document.body.addEventListener("mousemove", this.onMoveout)
    }
  }

  close(details) {
    var target = details || this.mainDetailsToggle
    target.removeAttribute('open');
    target.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('header-menu', HeaderMenu);
